import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/complaints/general/')({
    beforeLoad: ({ params }): never => {
        throw redirect({
            to: '/console/$orgId/configuration/compliance/complaints/general/lodgement',
            params,
            replace: true,
        });
    },
});
